<template>
    <v-card width="100%">
        <v-card-subtitle>
            <v-icon small color="orange">mdi-alarm-light</v-icon>
            - Золотая раздача. Скачанное в расчет не идет<br />
            <v-icon small color="grey">mdi-alarm-light</v-icon>
            - Серебрянная раздача. 50% скачанного учитывается
        </v-card-subtitle>
        <v-card-subtitle>
            <p v-if="userData.rt">Рейтинг на Кинозал.TV
                <span v-if="userData.rt >= 1.00" style="color: #00e676">{{ userData.rt }}</span>
                <span v-else style="color: darkred">{{ userData.rt }}</span>
                - необходимо держать более 1 <br />
                <span> Доступно в сутки - {{ userData.limit[0] }}</span><br />
                <span> Сегодня уже скачали - {{ userData.limit[1] }}</span><br />
            </p>
            <p v-else>
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </p>
        </v-card-subtitle>
        <v-card-text v-if="resultText.length > 0">
            <v-data-table :headers="headers" :items="resultSearch">
                <template v-slot:item.info="{ item }">
                    <v-icon small @click="openInfo(item.id)">
                        mdi-information-outline
                    </v-icon>
                </template>
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>{{ resultText }}</v-toolbar-title>
                    </v-toolbar>
                </template>
                <template v-slot:item.title="{ item }">
                    <v-icon v-show="itemStatus.find(x => x.value === item.status).show"
                        :color="itemStatus.find(x => x.value === item.status).color" small>mdi-alarm-light
                    </v-icon>
                    <span v-if="itemStatus.find(x => x.value === item.status).show"> - {{ item.title }}</span>
                    <span v-else> {{ item.title }}</span>
                </template>
                <template v-slot:item.action="{ item }">
                    <v-icon @click="downloadFile(item.id)">mdi-arrow-down-bold-box-outline</v-icon>
                </template>
            </v-data-table>
        </v-card-text>
        <download-choice ref="downloadChoice" />
        <detail-torrent ref="detailTorrent" />
    </v-card>
</template>

<script>
import downloadChoice from "@/components/downloadChoice"
import detailTorrent from "@/components/detailTorrent"

export default {
    name: "kinozal",
    components: { downloadChoice, detailTorrent },
    data() {
        return {
            file: 0,
            itemStatus: [
                { value: 'r0', show: false, color: 'black' },
                { value: 'r1', show: true, color: 'orange' },
                { value: 'r2', show: true, color: 'grey' },
                { value: 'r5', show: true, color: 'red' }
            ],
            headers: [
                { text: 'Инфо', value: 'info', width: '8%', align: 'center' },
                { text: 'Название', value: 'title' },
                { text: 'Размер', value: 'size', align: 'center' },
                { text: 'Источников', value: 'seeds', align: 'center' },
                { text: 'Скачать', value: 'action', align: 'center' }
            ]
        }
    },
    methods: {
        openInfo(id) {
            this.$refs.detailTorrent.getDetail(id)
        },
        downloadFile(id) {
            this.$refs.downloadChoice.open(id, 'kinozal')
        }
    },
    created() {
    },
    computed: {
        years() {
            const year = new Date().getFullYear()
            let yr = Array.from({ length: year - 1950 }, (value, index) => 1951 + index).reverse()
            yr.unshift('Все')
            return yr
        },
        resultSearch() {
            return this.$store.getters.resultSearch
        },
        resultText() {
            return this.$store.getters.resultText
        },
        userData() {
            return this.$store.getters.userData
        }
    }
}
</script>

<style scoped>
.searchNameInput {
    max-width: 300px;
}
</style>
